import { Stack, Typography } from "@mui/material";
import { useLocales } from "../../../locales";

export default function SeasonTicketStatus({ seasonTicket }) {
    const { translate } = useLocales();
    if (!seasonTicket) return null
    const { hrc, endUserSeasonTicket, numberOfTicketsEligibleForDiscount } = seasonTicket
    const { entryPassTicketsUsed, entryPassTotalTicketsAllowed, seasonTicketType } = endUserSeasonTicket

    return (<>
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>{seasonTicketType === "entry-pass" ? translate('dashboard.events.season_ticket_entry_pass') : translate('season_ticket.title')}</span>
                <span> - {hrc}</span>
            </Typography>
            {seasonTicketType === "entry-pass" && <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>
                    {translate('dashboard.events.entry_pass_usage', { 0: entryPassTicketsUsed, 1: entryPassTotalTicketsAllowed })}
                </span>
            </Typography>}
        </Stack>
        {numberOfTicketsEligibleForDiscount > 0 && <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>{translate('dashboard.events.available_entries')}</span>
            </Typography>
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>{numberOfTicketsEligibleForDiscount}</span>
            </Typography>
        </Stack>}
        {numberOfTicketsEligibleForDiscount == 0 && <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>{translate('dashboard.events.no_entries_left')}</span>
            </Typography>
        </Stack>}
    </>
    )
}
